export default {
  init: function(){
    $('[data-track-event]').on('click', function() {
      const data = {};

      $.each($(this).data(), (key, value) => {
        if (key.includes('track')) {
          if (key.includes('trackEvent')) {
            data['event'] = value;
          } else {
            data[key.substring(key.indexOf('track') + 5).toLowerCase()] = value;
          }
        }
      });

      dataLayer.push(data);
    });
  }
};